<template>
  <div class="public_main pbulic-head">
    <div class="main_content">
      <div class="mc-flex mc-flex-justify-between white-text mc-size12">
          <!-- 左侧 -->
          <div class="mc-flex">
              <div class="mc-flex mc-items-center">
                  <img src="@/assets/images/h_star.png" height="15" class="mc-mr-5" />
                  <a href="https://about.qx.com/" target="_blank" class="white-text">集团官网</a>
              </div>
              <div class="mc-flex mc-items-center mc-ml-40">
                  <img src="@/assets/images/h_computer.png" height="13" class="mc-mr-5" />
                  <a href="https://www.comix.com.cn/" target="_blank" class="white-text">齐心商城</a>
              </div>
              <div class="mc-flex mc-items-center mc-ml-40">
                  <img src="@/assets/images/h_position.png" height="15" class="mc-mr-5" />
                  <span>全国</span>
              </div>
          </div>
          <!-- 右侧 -->
          <div class="mc-flex mc-items-center">
              <div :class="userInfo ? 'yellow-text' : ''">
                  <!-- <template v-if="userInfo">
                      <span>{{userInfo.tel}}</span>
                      <span class="white-text mc-cursor-default mc-ml-10" @click="logout">退出</span>
                  </template>
                  <template v-else>
                      <router-link to="/login" class="yellow-text">请登录</router-link>
                      <router-link to="/register" class="white-text mc-ml-20">注册</router-link>
                  </template> -->
                  <a href="https://www.qx.com/Account/Login" class="white-text">您好,请登录</a>
                  <a href="https://www.qx.com/Account/Register" class="white-text mc-ml-20">免费注册</a>
                  <a href="https://www.qx.com/Account/Login" class="white-text mc-ml-20">我的订单</a>
              </div>
              <div class="mc-flex mc-items-center mc-ml-40">
                  <img src="@/assets/images/h_tel.png" height="15" class="mc-mr-5" />
                  <span>咨询电话：{{company.hotline}}</span>
              </div>
            <!-- <div class="line" style="margin-right: 0;"></div> -->
            <!-- <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
              <el-submenu index="1" :popper-append-to-body="false">
                <template slot="title" class>
                  <img
                    class="mc-mr-10"
                    src="@/assets/images/person_default.png"
                    width="14px"
                    height="14px"
                    alt
                  />
                  我的MRO
                </template>
                <el-menu-item>
                  <div class="menu-box mc-flex mc-flex-wrap">
                    <a href="https://www.qx.com/Account/Login">
                      <el-image :src="require('@/assets/images/person-icon.png')"></el-image>个人中心
                    </a>
                    <a href="https://www.qx.com/Account/Login">
                      <el-image :src="require('@/assets/images/order-icon.png')"></el-image>我的订单
                    </a>
                    <a href="https://www.qx.com/Account/Login">
                      <el-image :src="require('@/assets/images/advisory.png')"></el-image>我的咨询
                    </a>
                    <a href="https://www.qx.com/Account/Login">
                      <el-image :src="require('@/assets/images/collection.png')"></el-image>我的收藏
                    </a>
                  </div>
                </el-menu-item>
              </el-submenu>
            </el-menu> -->
            <!-- <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
              <span class="line" style="float:left;margin: 12px 0;"></span>
              <el-submenu index="2" :popper-append-to-body="false">
                <template slot="title">客服服务</template>
                <el-menu-item>
                  <div class="menu-box mc-flex mc-flex-wrap">
                    <router-link to>
                      <el-image :src="require('@/assets/images/server-icon.png')"></el-image>在线客服
                    </router-link>
                    <router-link to="/help">
                      <el-image :src="require('@/assets/images/question.png')"></el-image>帮助中心
                    </router-link>
                    <router-link to="/sale">
                      <el-image :src="require('@/assets/images/after-sale.png')"></el-image>售后服务
                    </router-link>
                    <router-link to="/feedback">
                      <el-image :src="require('@/assets/images/feedback.png')"></el-image>问题反馈
                    </router-link>
                  </div>
                </el-menu-item>
              </el-submenu>
            </el-menu> -->
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      activeIndex: "1",
    };
  },

  // components: {},

  computed: {
    ...mapState({
      userInfo: "userInfo",
      company: 'company'
    }),
  },

  mounted() {
  },

  methods: {
    ...mapMutations({
      REMOVE_USER: "REMOVE_USER",
    }),
    logout() {
      this.REMOVE_USER();
      this.$router.push("/login");
    },
  },
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/less.less";
.pbulic-head {
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: @gray6 !important;
  .line {
    height: 15px;
    border-right: 1px solid @white;
    margin: 12px 20px;
  }
  /deep/.el-menu {
    background: none !important;
    margin-top: 0;
    padding: 0;
    min-width: 0;
    .el-submenu {
      position: relative;
      .el-submenu__title {
        height: 40px;
        line-height: 40px;
        border-bottom: none;
        color: @white;
        &:hover {
          // background: none !important;
          color: @gray3;
          i {
            color: @gray3;
          }
        }
        i {
          color: @white;
        }
      }
      .el-menu--horizontal {
        right: 0 !important;
        left: unset !important;
        .el-menu-item {
          height: unset;
          .menu-box {
            width: 230px;
            a {
              width: 115px;
              display: flex;
              align-items: center;
              color: @gray3;
              .el-image {
                margin-right: 5px;
                width: 16px;
                height: 16px;
              }
            }
          }
        }
      }
      &.is-opened {
        .el-submenu__title {
          background: @white;
          color: @gray3;
          i {
            color: @gray3;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Head.vue